<template>
    <div class="row">
        <div class="col benefits">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="benefits__heading--al benefits__heading--plus"><h3>Your Positives</h3></div>
                    <ul class="benefits__list">
                        <li v-for="positive in positives" :key="positive.id" class="benefits__list__item">
                            <p class="paragraph benefits__list__item__content">
                                {{ positive.content }}
                            </p>
                        </li>
                    </ul>
                    <p v-if="positives.length < 1" class="paragraph">Looks like you’re too early in your EV journey to have any positive
                        areas yet.</p>
                </div>
                <div class="col-12 col-md-6">
                    <div class="benefits__heading--al benefits__heading--minus"><h3>Your Negatives</h3></div>
                    <ul class="benefits__list">
                        <li v-for="negative in negatives" :key="negative.id" class="benefits__list__item">
                            <p class="paragraph benefits__list__item__content">
                                {{ negative.content }}
                            </p>
                        </li>
                    </ul>

                    <p v-if="negatives.length < 1" class="paragraph">Great news, we have identified no areas for improvement</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="row benefits__heading--ac">
                        <div class="col">
                            <h3>Resources</h3>
                        </div>
                    </div>
                    <div class="row benefits__resource">
                        <div v-for="resource in resources" class="col-12 col-md" :key="resource.id">
                            <a :href="resource.link"
                               :id="resource.id"
                               target="_blank"
                               @click="trackResource(resource.caption, resource.link)">
                                <img :src="require(`@/assets/img/${resource.icon}.svg`)" :alt="resource.alt"/>
                                <span class="benefits__resource__caption">{{ resource.caption }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Benefits",
        data() {
            return {}
        },
        computed: {
            resources() {
                let resources = [];
                this.positives.forEach((v) => {
                    if (v.resource) {
                        Array.prototype.push.apply(resources, v.resource);
                    }
                });
                this.negatives.forEach((v) => {
                    if (v.resource) {
                        Array.prototype.push.apply(resources, v.resource);
                    }
                });
                let uniqueArray = resources.filter((thing, index) => {
                    return index === resources.findIndex(obj => {
                        return obj.id === thing.id;
                    });
                });
                return uniqueArray.slice(0, 6);
            },
            positives() {
                let values = this.$store.getters.getPositives;
                return values.sort((a, b) => b.weight - a.weight).slice(0, 3);
            },
            negatives() {
                let values = this.$store.getters.getNegatives;
                return values.sort((a, b) => b.weight - a.weight).slice(0, 3);
            },
            isAdmin() {
                return this.$store.state.admin;
            },
        },
        methods:{
            trackResource(caption, link) {
                if (!this.isAdmin) {
                    this.$gtag.logCTA('EV Maturity Tool - ' + caption + ' - ' + link);
                }
            }
        }
    }
</script>

<style scoped lang="stylus">
    .benefits
        margin-top 6.6rem
        padding 3rem
        background-color $color-grey

        &__heading
            &--al
                text-align left
                padding-left 8.2rem
                height 6.5rem
                background-repeat no-repeat
                background-size 6.5rem
                margin-bottom 2rem

                h3
                    line-height 6.5rem

            &--ac
                text-align center

            &--plus
                background-image url("~@/assets/img/positive-icon.svg")

            &--minus
                background-image url("~@/assets/img/negative-icon.svg")

        &__list
            &__item
                padding-left: 15px

                &__content
                    text-align left

        &__resource
            text-align center

            a
                &:hover
                    text-decoration none

                img
                    margin 2rem 0 1rem

            &__caption
                display block
                color $color-blue-petrol
                font $font-bold
                font-size 1.8rem
                line-height 2.8rem
                font-weight bold

</style>